export const toSearchParams = <T>(query?: T): URLSearchParams | undefined =>
  query &&
  Object.entries(query).reduce((params, [key, value]) => {
    if (value) {
      params.append(key, `${value}`)
    }
    return params
  }, new URLSearchParams())
